import { BybStepper } from "@Components/game/common/styled-components";
import PlaylistBannerCard from "@Components/game/playlists/highlighted/cards/playlist-banner-card";
import { usePlaylistsContext } from "@Context/game/playlists/playlists-context";
import { Box, Skeleton, useTheme } from "@mui/material";
import { useState } from "react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

interface IHighlightedPlaylist {}

const HighlightedPlaylist = ({}: IHighlightedPlaylist) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const { playlists, loading } = usePlaylistsContext();
  const maxSteps = playlists?.length || 0;

  return (
    <Box sx={{ width: "100%", height: theme.spacing(73.25), position: "relative", isolation: "isolate" }}>
      {loading ? (
        <Skeleton variant="rectangular" width="100%" height="100%" />
      ) : (
        <>
          <Swiper
            initialSlide={0}
            style={{ height: "100%" }}
            loop={maxSteps > 1}
            autoplay={{
              delay: 10000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            onSlideChange={(swiper) => setActiveStep(swiper.realIndex)}
          >
            {playlists
              ? playlists.filter(Boolean).map((playlist, index) => (
                  <SwiperSlide key={index} style={{ cursor: "pointer", height: "100%" }}>
                    {Math.abs(activeStep - index) <= 2 ? (
                      <PlaylistBannerCard
                        id={playlist.id}
                        name={playlist.name || ""}
                        description={playlist.description || ""}
                        imageUrl={playlist.image_url || ""}
                      />
                    ) : null}
                  </SwiperSlide>
                ))
              : [...Array(3)].map((_, index) => (
                  <SwiperSlide key={`empty-${index}`} style={{ height: "100%" }}>
                    <PlaylistBannerCard loading />
                  </SwiperSlide>
                ))}
          </Swiper>
          {maxSteps > 1 && <BybStepper steps={maxSteps} position="static" activeStep={activeStep} nextButton={null} backButton={null} />}
        </>
      )}
    </Box>
  );
};

export default HighlightedPlaylist;
